<!-- Hero Section -->
<div class="softwaredev-section-bg">
  <section class="softwaredev-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <h1 class="softwaredev-heading mb-3">
            Tech Geek Ed. 5
          </h1>
          <!-- <h3 class="softwaredev-subheading2 mb-4">
            Discover the fresh stories of Kalpita Technologies.
          </h3> -->
          <div class="mb-5 contact-btn">
            <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
            <!-- <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Explore Our Solutions
            </button> -->
          </div>
        </div>

        <div class="col-lg-7 text-center">
          <img src="../../../../assets/resources/techgeek/tech-geek-5-bannerimg.png" alt="Manager"
            class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- TL;DR Section with Image Icon -->
<section class="takeaways-section py-5">
  <div class="container">
    <h2 class="section-title text-center">TL;DR</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          Tech Geek Ed. 5 explores the evolution of 6G technology and how hyper-connectivity, terahertz communication,
          and AI-driven networks will reshape global digital infrastructure.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          The edition examines blockchain in marketing, covering fintech, healthtech, insurtech, and SaaS blockchain
          analytics for secure and transparent business processes.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          Next-generation AI wearables such as the OMI AI companion and Ray-Ban Meta smart glasses highlight
          voice-first, context-aware, and privacy-focused technology.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          Enterprise innovation is driven by intelligent automation through UiPath AI Center and AI-powered robotic
          process automation.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          AI in aviation is transforming predictive maintenance, fleet management, fuel efficiency, and safety across
          airline operations.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          Emerging tools such as Bitchat messaging and AI-powered browsers demonstrate the shift toward decentralized,
          privacy-first digital experiences.
        </p>
      </div>
    </div>
  </div>
</section>
<!-- Key Takeaways Section with Image Icon -->
<section class="takeaways-section pt-0 pb-5">
  <div class="container">
    <h2 class="section-title text-center">Key Takeaways</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>6G Network Rollout & Hyper Connectivity:</strong> 6G will enable ultra-low latency, terahertz
          communication, and AI-driven networks to power holographic communication, smart cities, and autonomous
          systems.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Blockchain in Marketing & Sales:</strong> Blockchain enhances trust, transparency, and automation
          across fintech, healthtech, insurtech, and SaaS customer engagement platforms.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AI Wearable Technology & Smart Devices:</strong> Multimodal AI wearables like OMI and Ray-Ban Meta
          enable real-time assistance, memory recall, and contextual intelligence.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Intelligent Automation with UiPath:</strong> AI-powered RPA automates complex enterprise workflows
          using document processing, predictive analytics, and decision intelligence.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AI in Aviation & Fleet Management:</strong> Predictive maintenance and real-time fleet optimization
          improve airline safety, cost efficiency, and operational resilience.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Decentralized Communication & AI Browsers:</strong> Bluetooth mesh messaging and agentic AI browsers
          represent the future of privacy-first, automation-driven digital communication.
        </p>
      </div>
    </div>
    <button class="btn case-study-btn" (click)="openModal()">
      Access Your Copy
    </button>
  </div>
</section>
<!-- Relevant Article -->
<app-relevant-techgeek></app-relevant-techgeek>

<!-- MODAL POPUP -->
<div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content-box">
    <button class="close-btn" (click)="closeModal()">&times;</button>

    <div class="modal-header" *ngIf="!submitSuccess">
      <h3>Access Your TechGeek Copy</h3>
      <p>Fill in your details to receive the Tech Geek Edition 5.</p>
    </div>

    <div *ngIf="submitSuccess" class="success-message text-center">
      <i class="ri-checkbox-circle-fill" style="color: #28a745; font-size: 3rem;"></i>
      <h4>Thank you!</h4>
      <p>Check your email for the download link.</p>
      <small style="color: #666;">Please check your spam folder if you don't see it.</small>
    </div>

    <form [formGroup]="downloadForm" (ngSubmit)="onSubmit()" *ngIf="!submitSuccess">
      <div class="form-group">
        <label>Full Name</label>
        <input type="text" formControlName="name" class="form-control" placeholder="Name">
        <div class="error-msg" *ngIf="downloadForm.get('name')?.touched && downloadForm.get('name')?.errors">

          <span *ngIf="downloadForm.get('name')?.errors?.['required']">
            Name is required
          </span>

          <span *ngIf="downloadForm.get('name')?.errors?.['pattern']">
            Name should contain only letters
          </span>

        </div>
      </div>

      <div class="form-group">
        <label>Email Address</label>
        <input type="email" formControlName="email" class="form-control" placeholder="Email">
        <div class="error-msg" *ngIf="downloadForm.get('email')?.touched && downloadForm.get('email')?.errors">

          <span *ngIf="downloadForm.get('email')?.errors?.['required']">
            Email is required
          </span>

          <span *ngIf="downloadForm.get('email')?.errors?.['pattern']">
            Enter a valid email address
          </span>

        </div>
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="modal-footer">
        <button type="submit" class="submit-btn" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Processing...' : 'Download Now' }}
        </button>
      </div>
    </form>
  </div>
</div>